<script>
import { toWorkerData } from './worker-data'
import SearchWorker from '../search.worker.js?worker'


export default {
    data() {
        return {
            searchIndexes: [],
            foundDataIds: null,
            searchWorker: null,
        }
    },
    watch: {
        search() {
            this.performSearch()
        },
        data() {
            this.createSearchIndexes()
        },
    },
    created() {
        this.searchWorker = new SearchWorker()
        this.searchWorker.addEventListener('message', (m) => {
            if (m.data.action == 'search') {
                this.foundDataIds = m.data.result
            }
        })
    },
    mounted() {
        this.createSearchIndexes()
    },
    unmounted() {
        if (this.searchWorker) {
            this.searchWorker.terminate()
            this.searchWorker = null
        }
    },
    computed: {
        searchedData() {
            if (this.search.trim() && this.foundDataIds) {
                // Iterate over sections (synchronous, authoritative props) rather than
                // foundDataIds, which is an async worker result that can be stale relative
                // to data/sections (e.g. data reshaped to fewer sections before the worker
                // catches up). Mirrors the robust pattern in displayData(). new Set(undefined)
                // yields an empty set, so a stale-shorter foundDataIds is handled gracefully.
                const result = []
                this.sections.forEach((section, sectionIdx) => {
                    const sectionIds = new Set(this.foundDataIds[sectionIdx])
                    result[sectionIdx] = this.data[sectionIdx].filter(r => sectionIds.has(r.id))
                })
                return result
            }
            return this.data
        },
    },
    methods: {
        createSearchIndexes() {
            // turn Vue 3 Proxy object into raw object before sending to worker via postMessage.
            // toWorkerData() first strips each row down to the fields the worker reads, so the
            // serialize doesn't walk the full document/employee/company payload on every row.
            const headers = JSON.parse(JSON.stringify(this.headers))  // May contain methods
            const sections = JSON.parse(JSON.stringify(this.sections))
            const data = JSON.parse(JSON.stringify(toWorkerData(this.data)))
            this.searchWorker.postMessage({
                action: 'create',
                headers: headers,
                sections: sections,
                data: data,
            })
        },
        performSearch() {
            if (this.search.trim()) {
                this.searchWorker.postMessage({
                    action: 'search',
                    search: this.search,
                })
            }
            else {
                this.foundDataIds = null
            }
        },
    },
}
</script>
